var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHideTemporary(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 141809",
    transform: "translate(-8327 -3741)",
    fill: "#deaa0c",
    stroke: "#707070",
    d: "M0 0h16v16H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Mask Group 1547",
    transform: "translate(8327 3741)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#deaa0c"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 48378",
    d: "M-8321.91-3733.727a.728.728 0 0 0 0 1.455h5.818a.728.728 0 0 0 0-1.455Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 48379",
    d: "M-8311.001-3733a8 8 0 1 1-8-8 8 8 0 0 1 8 8Zm-1.455 0a6.545 6.545 0 1 1-6.545-6.545 6.545 6.545 0 0 1 6.545 6.545Z",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHideTemporary);
export default __webpack_public_path__ + "static/media/Hide_Temporary.a3d899c7e090b60916257e90c30e9f0f.svg";
export { ForwardRef as ReactComponent };